import React, { FC, PropsWithChildren } from 'react';

import EmptyState from '../EmptyState';

import { ReactComponent as EmptyStateNoSongsIcon } from 'resources/img/svg/emptyStateNoSongs.svg';

import { EmptyStateProps } from '../interfaces';

const NoSongsFound: FC<PropsWithChildren<Pick<EmptyStateProps, 'size'>>> = ({ size, children }) => (
  <EmptyState className="noSongsFound" size={size} icon={EmptyStateNoSongsIcon}>
    {children}
  </EmptyState>
);

export default NoSongsFound;
